













































































import VueOptions from '@utils/VueOptions'
import CalendarService from '@services/CalendarService'
import TagBar from '@ui/TagBar'
import SponsorSetList from '@ui/SponsorSet/SponsorSetList'

settings =
  name: 'AudienceCreativeCard'

  vue:
    props: ['item', 'options', 'actions']

    components: {
      TagBar,
      SponsorSetList,
    }

    computed:
      editable: ->
        return @options.editable if @options?.editable?
        true

      draftCount: ->
        @ctxStats(@item).draft_availabilities_count

      publishedCount: ->
        @ctxStats(@item).published_availabilities_count

      hasSponsorSet: -> @sponsorSet.length > 0
      sponsorSet: -> @item.sponsor_set

      creativeDate: ->
        calendarDate = @item.date
        return '' unless calendarDate
        { starts_on: date, repeats, rrule_string: rruleString } = calendarDate
        { seasons } = @item
        CalendarService.formatCalendarDate { date, repeats, rruleString, seasons }

      tags: ->
        { formatTitle } = @$options.filters
        tags = [...[@item.primary_type], ...@item.types, ...@item.audience_tags, ...@item.activity_tags]
        tags = tags.filter(Boolean)
        uniqTags = Array.from(new Set(tags))
        { value: tag, label: formatTitle(tag) } for tag in uniqTags

      tagsFilter: -> []

      tagOptionsForTags: ->
        {
          bar: {
            theme: 'card',
            max: 4
          },
          tag: {
            theme: 'card',
            format: 'formatListingType',
            maxLength: 12
          }
        }

      superNotes: ->
        @item.super_notes.map((item) -> "- #{item.note}").join('</br>')

    methods:
      hiNavToEdit: ->
        @actions?.edit @item

      hiNavToPreview: ->
        @actions?.preview @item

      hiNavToShow: ->
        @actions?.show @item

export default VueOptions.vue settings
